import { ref } from 'vue'

import router from '@/router'

export default function usePopoverTrigger() {
  const isOpenRef = ref(false)
  const eventRef = ref<MouseEvent | null>(null)

  const close = () => {
    isOpenRef.value = false
    eventRef.value = null
  }

  const openOnClick = (e: MouseEvent) => {
    if (isOpenRef.value) {
      close()
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          eventRef.value = e
          isOpenRef.value = true
        })
      })
    } else {
      eventRef.value = e
      isOpenRef.value = true
    }
  }

  function openOnKey(ev: KeyboardEvent) {
    const target = ev.currentTarget as HTMLElement | null
    const rect = target?.getBoundingClientRect()
    const fake = new MouseEvent('click', {
      clientX: rect ? rect.left + rect.width / 2 : 0,
      clientY: rect ? rect.top + rect.height / 2 : 0,
      bubbles: true,
    })
    openOnClick(fake)
  }

  router.afterEach(() => close())

  return { isOpenRef, eventRef, close, openOnClick, openOnKey }
}
